<app-header-title>
  <span title>{{'addemployee.EmployeesInformation' | translate}}</span>
</app-header-title>

<div class="publicsetting" style="padding: 2rem 3rem;">
    <!-- <h2 class="content-block title animate__animated animate__fadeIn">{{'addemployee.EmployeesInformation' | translate}}</h2> -->
    <dx-data-grid #grid
      class="dx-card wide-card" 
      [dataSource]="customDataSource" 
      [showBorders]="false" 
      keyExpr="id"
      [focusedRowEnabled]="true" 
      [focusedRowIndex]="0" 
      [allowColumnResizing]="true" 
      [columnAutoWidth]="true"
      [columnHidingEnabled]="true" 
      [showColumnLines]="false" 
      [rowAlternationEnabled]="true" 
      [showRowLines]="false"
      [showBorders]="false" 
      [errorRowEnabled]="false" 
      [rtlEnabled]="currentLang === 'ar'"
   
>
    
      <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
      <dxo-pager [visible]="true"></dxo-pager>
    
      <dxo-editing mode="row" [useIcons]="false" 
        [texts]="button">
        
      </dxo-editing>
  
      <dxo-paging [pageSize]="10"></dxo-paging>
  
      <dxo-pager 
        [visible]="true" 
        allowedPageSizes="true" 
        displayMode="full" 
        [showPageSizeSelector]="true" 
        [showInfo]="false" 
        [showNavigationButtons]="true">
      </dxo-pager>
      
      <dxo-filter-row [visible]="true"></dxo-filter-row>
  
      <dxi-column dataField="employeeId"  caption="{{'salary.employeeId'|translate}}">
      </dxi-column>
      <dxi-column dataField="employeeNameAr"  caption="{{'tableinfo.NameAr' | translate}}" >
      </dxi-column>
      <dxi-column dataField="employeeNameEn"  caption="{{'tableinfo.NameEn' | translate}}" >
    </dxi-column>
    <dxi-column dataField="isActive" caption="{{'tableinfo.isActive'|translate}}">
    </dxi-column>
    <dxi-column dataField="isInsurance" caption="{{'addemployee.tab1.isinsurance' | translate}}"></dxi-column>
  
    <dxi-column dataField="employeeWorkStatus" caption="{{'tableinfo.employeeWorkStatus' | translate}}" [allowEditing]="true">
  
    </dxi-column>
    <dxi-column dataField="employeeWorkSystem"  caption="{{'tableinfo.workSystem' | translate}}" >
    </dxi-column>
    <dxi-column dataField="nationalID"  caption="{{'addemployee.tab1.NationalID' | translate}}" >
    </dxi-column>
    <dxi-column dataField="createdUserId" caption="{{'cdc.UserName' | translate}}">
      <dxo-lookup
        [dataSource]="UserDropDown"
        valueExpr="id"
        displayExpr="userName">
      </dxo-lookup>
      <dxo-label template="{{'cdc.userName' | translate}}"></dxo-label>
    </dxi-column>
      <dxi-column dataField="branchId" caption="{{'basic-info.branch.branchName'|translate}}"[allowEditing]="false">
        <dxo-lookup
        [dataSource]="branchesdropdown"
        valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
      </dxi-column>
      <!-- <dxi-column dataField="accountId" caption="{{'basic-info.accountId'|translate}}"[allowEditing]="false">
        <dxo-lookup
        [dataSource]="branchesdropdown"
        valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
      </dxi-column> -->
      <dxi-column dataField="jobTitleId" caption="{{'salary.jobTitleId'|translate}}" [allowEditing]="false">
        <dxo-lookup
        [dataSource]="jobTitleDropDown"
        valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
      </dxi-column>
      <dxi-column dataField="departmentId" caption="{{'salary.department'|translate}}" [allowEditing]="false">
        <dxo-lookup
        [dataSource]="departmentDropDown"
        valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameEn'"></dxo-lookup>
      </dxi-column>
     
      <dxi-column dataField="bankCode" caption="{{'addemployee.tab1.bankCode'|translate}}" [allowEditing]="false">
      </dxi-column>
      <dxi-column dataField="fingerPrintNumber" caption="{{'addemployee.tab1.FingerPrintNumber'|translate}}" [allowEditing]="false"></dxi-column>
      
      
    </dx-data-grid>
  </div>
  